const colorMap = {
  "Indigo Purple": "#67176B",
  "Jet Black": "#242026",
  "Light Lavender": "#9189AC",
  "Melon Peach": "#D4978D",
  "Mustard Yellow": "#E6B76B",
  "Porcelain White": "#CED4E2",
  "Skyway Blue": "#9EB6CB",
  "Navy Blue": "#152543",
  "Nude Brown": "#AB9689",
  "Onyx Black": "#020202",
  "Opera Mauve": "#5C4043",
  "Pastel Sage Green": "#B1AE98",
  "BLACK GARNET": "#1C1B1E",
  "Bottle green": "#233C2D",
  "Burgundy": "#532D35",
  "CANARY YELLOW": "#D3AE55",
  "Carnation Pink": "#D0A5A7",
  "Cavair Black": "#0E0C0C",
  "COAL BLACK": "#090909",
  "COBALT BLUE": "#072337",
  "Coffee": "#342224",
  "CREAM BEIGE": "#CBC2B5",
  "CREAM LILAC": "#B489B3",
  "Cream white": "#D3C3BA",
  "CREAM WHITE": "#D3C3BA",
  "Crimson Red": "#D30623",
  "DAISY WHITE": "#D1D1CD",
  "Dark Grape": "#230D1F",
  "Dark Grey": "#383836",
  "Dark Olive": "#4B3C2A",
  "Dark Pink": "#CC0034",
  "DEEP MAROON": "#24100E",
  "DEEP MAUVE": "#675660",
  "Deep Purple": "#230920",
  "DOVE WHITE": "#D5CCBD",
  "Fuscia Pink": "#B6003D",
  "GOLD CREAM": "#C6BAA8",
  "Gradience of pink & yellow": "#DCA983",
  "GREEN BLACK": "#1C322D",
  "INDIGO BLUE": "#202231",
  "Ivory": "#CAAD8E",
  "IVORY PINK": "#D3CDC5",
  "Ivory White": "#E6D2CE",
  "IVORY WHITE": "#D5D0C2",
  "JADE BLACK": "#070707",
  "LIGHT PEACH": "#C7B09B",
  "Light Peach": "#E4C4BF",
  "Light Pink": "#D8BAB2",
  "Lilac": "#B69A9E",
  "LIME WHITE": "#D0C895",
  "Lipstick Red": "#C6011F",
  "Magenta Pink": "#E80144",
  "Maroon Red": "#56101E",
  "Mauve": "#BA9DB2",
  "Midnight blue": "#1E1D25",
  "MIDNIGHT BLUE": "#1A1D26",
  "MIDNIGHT PURPLE": "#5B5665",
  "Multi": "multicolor.png",
  "Multi colour": "multicolor.png",
  "Multi-Colored": "multicolor.png",
  "Multicoloured": "multicolor.png",
  "Mustard": "#D5AF84",
  "NUDE CREAM": "#DBD2C4",
  "Off-White": "#D4D6CA",
  "Onion Pink": "#995F65",
  "ONION PINK": "#4B363B",
  "PALE LILAC": "#98858A",
  "Pale mauve": "#A5969B",
  "Peach": "#D1B69B",
  "PEACH ROSE": "#E4CFBE",
  "Petal Pink": "#D1A18F",
  "PINE GREEN": "#2F4548",
  "Pine green": "#043324",
  "Pista": "#DDD8C3",
  "PISTACHIO GREEN": "#ACC0B7",
  "PITCH BLACK": "#030303",
  "RAVEN BLACK": "#2A2829",
  "RICH LILAC": "#B9A8AC",
  "Rose": "#BAA5AA",
  "ROSE PEACH": "#D8C0B6",
  "ROSE WHITE": "#EACDC0",
  "Royal Blue": "#2A2C3B",
  "SABLE BLACK": "#131315",
  "SANGRIA WINE": "#1C1515",
  "SAPPHIRE BLUE": "#415763",
  "Smoke Grey": "#CCD0D3",
  "White": "#F1DED2",
  "YALE BLUE": "#0B1F25",
  "Albaster white": "#D8D5CF",
  "Beige white": "#DAD3C7",
  "Berry Red": "#501C1D",
  "Black and Grey": "#232828",
  "Blue and green": "#1C2735",
  "Brick red": "#8B3D25",
  "Bright yellow": "#D6A75C",
  "Cadmium green": "#172020",
  "Castleton green": "#26332A",
  "Cherry red": "#54272D",
  "Cocoa brown": "#71543B",
  "Dark blue": "#051a4b",
  "Dark green": "#132120",
  "Deep-sea green": "#0B1621",
  "Fade lilac": "#AD9DA7",
  "Garnet Red": "#72292B",
  "Granola Cream": "#B9A07B",
  "Green & Blue": "#5F7041",
  "Ink black": "#1C1C1C",
  "Iron Grey": "#19171F",
  "Light blue": "#CED6CF",
  "Light Cream Lemon": "#E5CD8F",
  "Light lemon": "#9C8D6A",
  "Light lilac": "#C5BDB7",
  "Light purple": "#987578",
  "Light yellow": "#B38733",
  "Baby pink": "#E89198",
  "Dusty pink": "#DDA1A3",
  "Peacock blue": "#07354C",
  "Sage Green & Yellow": "#C1BBA9",
  "Soft champagne": "#BE9887",
  "Sea green": "#2C6861",
  "Sage green": "#A1895F",
  "Tea green": "#E2CA84",
  "Off White": "#B7A594",
  "Olive Green": "#61523E",
  "Silver & Wine": "#5D3635",
  "Taupe": "#64554E",
  "White-Lilac": "#C3AB9E",
  "White-Wine": "#8D564B",
  "Wine": "#3B1E25",
  "Steel grey": "#7F8382",
  "Teal blue": "#015357",
  "SEASHELL WHITE": "#D5CCBF",
  "Pistachio": "#878163",
  "Skycream Multicoloured": "#605730",
  "Vivid Yellow": "#C98A4B",
  "White lavender": "#C0BCB9",
  "White lemon": "#A7A35C",
  "White pink": "#B09685",
  "Mehendi green": "#36321F",
  "Pastel blue": "#6B7C86",
  "Red Cherry": "#5B2129",
  "Sunglow yellow": "#A7781B",
  "Turmeric Yellow": "#D3A364",
  "WHITE LILAC": "#AF8FAE",
  "Beige": "#e7d5b3",
  "Cream": "#f2eee4",
  "White": "#ffffff",
  "Powder Blue": "#91b4d2",
  "Purple and Green": "#d89fa2",
  "Ombre": "#e1aaad",
  "Light Pink and Green": "#d8a59c",
  "Sky Blue": "#a8bbc3",
  "Golden": "#d9c29e",
  "Purple & Red": "#563268",
  "Pista Green": "#c7b27f",
  "Rani Pink": "#d1013f",
  "Pearl White": "#e8e3d7",
  "White & Yellow": "#fbd48f",
  "Bright Red": "#e5323d",
  "Celestial Blue": "#a7abb9",
  "Dusty Rose": "#a28490",
  "Brick Red & Black": "#8c5655",
  "Sky": "#a1b1a8",
  "Mocha Brown": "#928469",
  "Rani": "#f60069",
  "Nude pink": "#b08573",
  "Apple Red": "#59161b",
  "Rose Pink": "#e687a5",
  "Deep Teal": "#075456",
  "Multi Purple": "#5a1f53",
  "Multi Teal Blue": "#173b51",
  "Multi Beige": "#deb3a6",
  "Multi Black": "#2e2225",
  "Lavender": "#6884d8",
  "Green & White": "#a7a07c",
  "Purple & White": "#6b324c",
  "Multi Color": "multicolor.png",
  "Teal Green": "#19354b",
  "Pink & Green": "#f9559e",
  "Pastel": "#f3ccaf",
  "Multicolor": "multicolor.png",
  "Multicolour": "multicolor.png",
  "Multicoloured": "multicolor.png",
  "Multi Coloured": "multicolor.png",
  "Multi Colour": "multicolor.png",
  "Rose gold": "#e0d2c8",
  "Grey & Yellow": "#c3b097",
  "Lime Green": "#c0ba5d",
  "Light Pista": "#c5bd9a",
  "Light Grey": "#aeb0af",
  "Omray": "#405659",
  "Mahendi": "#677e3d",
  "Pink & Purple": "#f7386a",
  "Fuchsia Pink": "#dc4a60",
  "Deep Pink": "#bf5f84",
  "Black & White": "#161614",
  "Ash purple": "#604c4e",
  "Rani & Cream": "#ed7074",
  "Vibrant red": "#f20624",
  "Dusty mauve": "#64443b",
  "Champagne": "#e5c3a6",
  "Pale Golden": "#d7bc86",
  "Dark fuchsia": "#bd3e53",
  "Palm Green": "#c7c178",
  "Dusty rose pink": "#e16071",
  "Cherry": "#b5050c",
  "Red & White": "#d71432",
  "Rust": "#981917",
  "Mehandi": "#766960",
  "Dark brown": "#433534",
  "Pristine white": "#ffffff",
  "Rose gold white": "#c0ae9f",
  "Ivory mustard yellow": "#a78d2b",
  "White & Golden": "#e4d6c9",
  "Berry Blue": "#1d2230",
  "Snow white": "#ffffff",
  "Orchid Purple": "#bca7aa",
  "Light Soft Cyan": "#b2c0b1",
  "N Blue": "#323443",
  "Iris Purple": "#493b53",
  "Rama": "#048c7c",
  "Dove Grey": "#9f9398",
  "Slate Grey": "#5b5a5f",
  "Lilac Ombre": "#cbafc0"
};
const h1TagMapping = {
  home: {
    current: "Riyaasat | Shop the look | Shop by Category | Shop by occasion | Visit our stores",
    revised: "Riyaasat – Best Ethnic Wear Online Store for Men & Women",
  },

  mensEthnic: {
    current: "Men's Wear",
    revised: "Men’s Ethnic Wear",
  },

  womensEthnic: {
    current: "Women's Wear",
    revised: "Women's Ethnic Wear",
  },

  kurtaSet: {
    current: "Kurta Set",
    revised: "Men's Kurta Sets",
  },

  kotiSets: {
    current: "Kurta Jacket Set",
    revised: "Kurta Pyjama Jacket Sets",
  },

  mensIndoWestern: {
    current: "Mens Indo Western",
    revised: "Indo-Western Suits for Men",
  },

  jodhpuriSet: {
    current: "Jodhpuri Set",
    revised: "Jodhpuri Suits for Men",
  },

  sherwani: {
    current: "Sherwani",
    revised: "Sherwani for Men",
  },

  tuxedoSet: {
    current: "Tuxedo Set",
    revised: "Tuxedo Suits for Men",
  },

  lehengaCholis: {
    current: "Lehenga Cholis",
    revised: "Lehenga Choli for Women",
  },

  bridalLehenga: {
    current: "Bridal Lehenga",
    revised: "Bridal Lehengas for Women",
  },

  salwarSuits: {
    current: "Salwar Suits",
    revised: "Salwar Suits for Women",
  },

  anarkaliSuits: {
    current: "Anarkali Suits",
    revised: "Anarkali Suits for Women",
  },

  shararaSuits: {
    current: "SHARARA SUITS",
    revised: "Sharara Suits for Women",
  },

  palazzoSuits: {
    current: "Palazzo Suits",
    revised: "Palazzo Suits for Women",
  },

  indoWesternDressesForWomen: {
    current: "Indowestern",
    revised: "Indo Western Dresses for Women",
  },

  sarees: {
    current: "Sarees",
    revised: "Sarees",
  },

  preDrapedSarees: {
    current: "Pre Drape Saree",
    revised: "Pre-Draped Sarees",
  },

  silkSarees: {
    current: "Silk Sarees",
    revised: "Pure Silk Sarees",
  },

  groom: {
    current: "Groom",
    revised: "Wedding Dresses for Groom",
  },

  receptionDressesForWomen: {
    current: "RECEPTION READY",
    revised: "Reception Dresses for Women",
  },

  engagementDressesForWomen: {
    current: "ENGAGEMENT PICKS",
    revised: "Engagement Dresses for Women",
  },

  haldiDressForWomen: {
    current: "HALDI HUES",
    revised: "Haldi Dresses for Women",
  },

  weddingDressesForWomen: {
    current: "WEDDING GLAM",
    revised: "Wedding Dresses for Women",
  },

  mehndiDressForWomen: {
    current: "MEHENDI MOOD",
    revised: "Mehndi Dresses for Women",
  },

  cocktailDressesForWomen: {
    current: "COCKTAIL COUTURE",
    revised: "Cocktail Dresses for Women",
  },

  sangeetDressForWomen: {
    current: "Sangeet",
    revised: "Sangeet Dress for Women",
  },

  gownsForWomen: {
    current: "Gown",
    revised: "Gowns for Women",
  },

  bridesmaidOutfits: {
    current: "BRIDESMAID",
    revised: "Bridesmaid for Women",
  },

  groomsmen: {
    current: "GROOMSMEN",
    revised: "Groomsmen Dresses",
  },
};

const WIZZY_IWISH_OUTLINE_ICON =
  '\x3C!-- BEGIN app snippet: v3-all-svgs -->\n\t<svg viewBox="0 0 256 256" width="20" class="iwishOutline" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"/><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>\n\n\x3C!-- END app snippet -->';
const WIZZY_IWISH_FILLED_ICON =
  '\x3C!-- BEGIN app snippet: v3-all-svgs -->\n\n\t<svg viewBox="0 0 256 256" width="20" class="iwishFill" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"/><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="#000000" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>\n\x3C!-- END app snippet --> ';

function wizzyEnsureWishlistIconConfig() {
  window.iWishData = window.iWishData || {};
  window.iWishData.iwish_add_txt = WIZZY_IWISH_OUTLINE_ICON;
  window.iWishData.iwish_add_txt_col = WIZZY_IWISH_OUTLINE_ICON;
  window.iWishData.iwish_added_txt = WIZZY_IWISH_FILLED_ICON;
  window.iWishData.iwish_added_txt_col = WIZZY_IWISH_FILLED_ICON;
}
const getRevisedH1Tag = (categoryName) => {
  if (!categoryName) return categoryName;

  const normalizedCategoryName = categoryName.trim().toLowerCase();

  const matchedItem = Object.values(h1TagMapping).find((item) => {
    return item.current.trim().toLowerCase() === normalizedCategoryName;
  });

  return matchedItem ? matchedItem.revised : categoryName;
};

/** Wizzy PLP / autocomplete: clamp long product titles, offer Show more / Show less (delegated click). */
function wizzyInitPlpProductTitleClamp(scopeEl) {
  var root = scopeEl || document;
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll('.wz-plp-title-wrap').forEach(function (wrap) {
    var textEl = wrap.querySelector('.wz-plp-title-text');
    var toggle = wrap.querySelector('.wz-plp-title-toggle');
    if (!textEl || !toggle) return;

    wrap.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Show more';
    toggle.hidden = true;

    function measure() {
      if (wrap.classList.contains('is-expanded')) return;
      var overflowed = textEl.scrollHeight - textEl.clientHeight > 2;
      toggle.hidden = !overflowed;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        try {
          measure();
        } catch (eM) {}
      });
    });
  });
}

if (!window.__wizzyPlpTitleToggleBound) {
  window.__wizzyPlpTitleToggleBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.wz-plp-title-toggle');
    if (!btn) return;
    var wrap = btn.closest('.wz-plp-title-wrap');
    if (!wrap) return;
    try {
      e.preventDefault();
      e.stopPropagation();
    } catch (e0) {}
    var expanded = wrap.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? 'Show less' : 'Show more';
    if (!expanded) {
      try {
        var textEl = wrap.querySelector('.wz-plp-title-text');
        if (textEl) {
          window.requestAnimationFrame(function () {
            var overflowed = textEl.scrollHeight - textEl.clientHeight > 2;
            btn.hidden = !overflowed;
          });
        }
      } catch (e1) {}
    } else {
      btn.hidden = false;
    }
  });
}

function wizzyInitFacetSectionSearch(scopeEl) {
  var root = scopeEl || document;
  root.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
    var input = block.querySelector('input.facet-head-search-input');
    var list = block.querySelector('ul.wizzy-facet-list');
    if (!input || !list) return;

    // If Wizzy decides a facet is not searchable, the icon wrapper isn't rendered.
    // We still keep filtering local + client-side only.
    if (input.__wzBound) return;
    input.__wzBound = true;

    // Make the magnifier behave like the reference UI: click focuses the input (no navigation / no extra panel).
    var iconLink = block.querySelector('.facet-search-wrapper .facet-head-search a.facet-head-search-icon');
    if (iconLink && !iconLink.__wzBound) {
      iconLink.__wzBound = true;
      iconLink.addEventListener('click', function (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
        } catch (e0) {}
        try {
          input.focus();
        } catch (e1) {}
      });
    }

    // Auto-focus when the facet expands.
    // Click handlers are unreliable because Wizzy/theme may toggle `.collapsed` after our handler or re-render the block.
    // Instead, observe class changes and focus when `.collapsed` is removed.
    if (!block.__wzAutoFocusObserver) {
      block.__wzWasCollapsed = block.classList.contains('collapsed');
      try {
        block.__wzAutoFocusObserver = new MutationObserver(function () {
          try {
            var nowCollapsed = block.classList.contains('collapsed');
            if (block.__wzWasCollapsed && !nowCollapsed) {
              // Expanded
              requestAnimationFrame(function () {
                try {
                  // Don't steal focus if user is typing elsewhere.
                  var active = document.activeElement;
                  if (active && active.tagName && active.tagName.toLowerCase() === 'input' && active !== input) return;
                  input.focus();
                  wizzyFacetDebugLog('facet search autofocus', block.getAttribute('data-key') || '', input.id || '');
                } catch (e2) {}
              });
            }
            block.__wzWasCollapsed = nowCollapsed;
          } catch (e3) {}
        });
        block.__wzAutoFocusObserver.observe(block, { attributes: true, attributeFilter: ['class'] });
      } catch (eObs) {}
    }

    var onInput = function () {
      var q = (input.value || '').trim().toLowerCase();
      var items = list.querySelectorAll('.wizzy-facet-list-item');
      items.forEach(function (li) {
        var term = (li.getAttribute('data-term') || li.textContent || '').toLowerCase();
        var match = !q || term.indexOf(q) !== -1;
        li.style.display = match ? '' : 'none';
      });
    };

    input.addEventListener('input', onInput);
  });
}

function wizzyInitFacetSeeMore(scopeEl, rivasatVisibleCount) {
  var root = scopeEl || document;
  var rivLimit = typeof rivasatVisibleCount === 'number' ? rivasatVisibleCount : 3;

  function rivasatClearTruncateLis(lis) {
    lis.forEach(function (li) {
      li.classList.remove('rivasat-facet-truncate-hide');
      try {
        li.style.removeProperty('display');
      } catch (e0) {}
    });
  }

  function rivasatSetTruncatedHidden(li, hidden) {
    if (hidden) {
      li.classList.add('rivasat-facet-truncate-hide');
      try {
        li.style.setProperty('display', 'none', 'important');
      } catch (e1) {
        li.style.display = 'none';
      }
    } else {
      li.classList.remove('rivasat-facet-truncate-hide');
      try {
        li.style.removeProperty('display');
      } catch (e2) {}
    }
  }

  var sidebar = root.querySelector('.wizzy-search-filters-left.rivasat-filter-sidebar');
  if (sidebar) {
    sidebar.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
      var list = block.querySelector('ul.wizzy-facet-list');
      var btn = block.querySelector('button.wizzy-facet-see-more');
      if (!list || !btn) return;

      var allLis = Array.prototype.filter.call(list.children, function (n) {
        return n.nodeType === 1 && n.classList && n.classList.contains('wizzy-facet-list-item');
      });

      if (!allLis.length) {
        try {
          allLis = Array.prototype.slice.call(list.querySelectorAll(':scope > li.wizzy-facet-list-item'));
        } catch (eScope) {
          allLis = [];
        }
      }
      if (!allLis.length) {
        allLis = Array.prototype.slice.call(list.querySelectorAll('li.wizzy-facet-list-item'));
      }

      var optionLis = allLis.filter(function (li) {
        return !li.classList.contains('facet-range-item');
      });

      var facetKey = block.getAttribute('data-key') || '';
      var sig = facetKey + ':' + optionLis.length + ':' + allLis.length;
      if (block.__wzSeeMoreSig !== sig) {
        block.__wzSeeMoreSig = sig;
        block.__wzSeeMoreCollapsed = true;
      }
      if (block.__wzSeeMoreCollapsed === undefined) block.__wzSeeMoreCollapsed = true;

      function clearTruncate() {
        rivasatClearTruncateLis(allLis);
      }

      function apply() {
        clearTruncate();
        var collapsed = !!block.__wzSeeMoreCollapsed;

        if (optionLis.length <= rivLimit) {
          btn.hidden = true;
          btn.onclick = null;
          if (wizzyFacetDebugEnabled()) {
            wizzyFacetDebugLog('see-more: hide button (few rows)', facetKey, optionLis.length);
          }
          return;
        }

        btn.hidden = false;
        btn.textContent = collapsed ? 'See More' : 'See Less';

        if (collapsed) {
          optionLis.forEach(function (li, idx) {
            if (idx >= rivLimit) rivasatSetTruncatedHidden(li, true);
          });
        }

        if (wizzyFacetDebugEnabled()) {
          var hiddenN = optionLis.filter(function (li) {
            return li.classList.contains('rivasat-facet-truncate-hide');
          }).length;
          wizzyFacetDebugLog('see-more: apply', {
            facetKey: facetKey,
            collapsed: collapsed,
            optionRows: optionLis.length,
            hiddenRows: hiddenN,
            rivLimit: rivLimit,
          });
        }

        var input = block.querySelector('input.facet-head-search-input');
        if (input && String(input.value || '').trim()) {
          try {
            input.dispatchEvent(new Event('input', { bubbles: true }));
          } catch (e1) {}
        }
      }

      apply();

      btn.onclick = function () {
        block.__wzSeeMoreCollapsed = !block.__wzSeeMoreCollapsed;
        apply();
      };
    });
  }

  /* Top / non-Rivasat facets: keep previous numeric hide behaviour */
  var legacyLimit = 6;
  root.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
    if (block.closest('.rivasat-filter-sidebar')) return;
    var list = block.querySelector('ul.wizzy-facet-list');
    var btn = block.querySelector('button.wizzy-facet-see-more');
    if (!list || !btn) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('.wizzy-facet-list-item'));

    /* Tile/grid colour strip (img-2): horizontal scroll — do not hide pills; hide redundant See More */
    if (block.classList.contains('wizzy-grid-filters-box')) {
      var wrapGrid = block.closest('.wizzy-search-wrapper');
      if (wrapGrid && wrapGrid.classList.contains('display-tile-view')) {
        btn.hidden = true;
        items.forEach(function (li) {
          li.hidden = false;
          try {
            li.style.removeProperty('display');
          } catch (eLi) {}
        });
        return;
      }
    }
    if (items.length <= legacyLimit) {
      btn.hidden = true;
      items.forEach(function (li) {
        li.hidden = false;
      });
      return;
    }

    if (btn.__wzBound) return;
    btn.__wzBound = true;

    var collapsed = true;
    var render = function () {
      items.forEach(function (li, idx) {
        var isActive = li.classList.contains('active');
        li.hidden = collapsed ? idx >= legacyLimit && !isActive : false;
      });
      btn.hidden = false;
      btn.textContent = collapsed ? 'See More' : 'See Less';
    };

    btn.addEventListener('click', function () {
      collapsed = !collapsed;
      render();
    });

    render();
  });
}

function wizzyNormalizeAppliedFilters(scopeEl) {
  // Transform Wizzy's selectedFacets HTML into the required pill UI, while keeping
  // existing remove URLs intact. UI-only.
  var root = scopeEl || document;
  var appliedRoot = root.querySelector('[data-wz-applied-filters]');
  if (!appliedRoot) return;

  var source = appliedRoot.querySelector('.custom-applied-filters__source');
  var list = appliedRoot.querySelector('.custom-applied-filters__list');
  var headerBtn = appliedRoot.querySelector('.custom-applied-filters__header');
  if (!source || !list || !headerBtn) return;

  function normalizeText(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  function valueOnlyFromLabel(txt) {
    // "Categories : Lehenga Choli" -> "Lehenga Choli"
    // "Color: Beige (1)" -> "Beige (1)"
    var t = normalizeText(txt).replace(/[×✕]/g, '').trim();
    if (!t) return '';
    var parts = t.split(':');
    if (parts.length >= 2) return normalizeText(parts.slice(1).join(':'));
    return t;
  }

  function normalizeKeyForFacetMatch(s) {
    return String(s || '')
      .replace(/\(\s*\d+\s*\)\s*$/g, '')
      .replace(/[×✕]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function facetRowDisplayWithCount(li) {
    var nameEl = li.querySelector('.facet-item-label-value');
    var countEl = li.querySelector('.wizzy-facet-list-item-count');
    var name = nameEl ? normalizeText(nameEl.textContent) : '';
    var cnt = countEl ? normalizeText(countEl.textContent) : '';
    if (name && cnt) return normalizeText(name + ' ' + cnt);
    if (name) return name;
    return '';
  }

  /** Wizzy applied-facets text often omits "(n)"; copy visible facet row label + count when we can match. */
  function enrichLabelFromFacetDom(label) {
    var wrap = appliedRoot.closest('.wizzy-search-wrapper');
    if (!wrap || !label) return label;
    var key = normalizeKeyForFacetMatch(label);
    if (!key) return label;
    var listItems = wrap.querySelectorAll('.wizzy-facet-list-item');
    var foundSelected = '';
    var foundAny = '';
    for (var i = 0; i < listItems.length; i++) {
      var li = listItems[i];
      var dt = normalizeKeyForFacetMatch(li.getAttribute('data-term') || '');
      var nv = '';
      var nEl = li.querySelector('.facet-item-label-value');
      if (nEl) nv = normalizeKeyForFacetMatch(nEl.textContent || '');
      if (dt !== key && nv !== key) continue;
      var disp = facetRowDisplayWithCount(li);
      if (!disp) continue;
      var inp = li.querySelector('input.dot-checkbox, input.wz-checkbox');
      var isSel = li.classList.contains('active') || (inp && inp.checked);
      if (isSel) foundSelected = disp;
      if (!foundAny) foundAny = disp;
    }
    return foundSelected || foundAny || label;
  }

  list.innerHTML = '';
  // Extract applied facet items from whatever Wizzy rendered.
  // Prefer anchors with href. If not present, fall back to list items / buttons / direct children,
  // and keep removal behavior by proxy-clicking the original element.
  var candidates = [];

  var anchorLinks = Array.prototype.slice
    .call(source.querySelectorAll('a[href]'))
    .filter(function (a) {
      var href = a.getAttribute('href') || '';
      return href && href !== '#';
    });
  if (anchorLinks.length) {
    candidates = anchorLinks;
  } else {
    var lis = Array.prototype.slice.call(source.querySelectorAll('li'));
    if (lis.length) {
      candidates = lis;
    } else {
      // Last resort: direct element children
      candidates = Array.prototype.slice.call(source.children || []);
    }
  }

  candidates.forEach(function (node) {
    if (!node || node.nodeType !== 1) return;

    var href = node.tagName && node.tagName.toLowerCase() === 'a' ? node.getAttribute('href') : '';
    var raw = node.textContent || '';
    var label = valueOnlyFromLabel(raw);
    if (!label) return;
    label = enrichLabelFromFacetDom(label);

    var pill =
      href && href !== '#'
        ? document.createElement('a')
        : document.createElement('button');

    pill.className = 'custom-applied-filters__pill';
    if (pill.tagName.toLowerCase() === 'a') {
      pill.href = href;
      pill.setAttribute('data-no-instant', '');
    } else {
      pill.type = 'button';
    }

    var textSpan = document.createElement('span');
    textSpan.textContent = label;

    var removeSpan = document.createElement('span');
    removeSpan.className = 'custom-applied-filters__remove';
    removeSpan.textContent = '×';

    pill.appendChild(textSpan);
    pill.appendChild(removeSpan);

    // Preserve removal behavior without knowing Wizzy internals:
    // clicking the pill triggers the original element (or its first link) click.
    pill.addEventListener('click', function (e) {
      // For <a>, let navigation happen if it’s a real remove URL.
      if (pill.tagName.toLowerCase() === 'a') return;
      e.preventDefault();
      try {
        var innerLink = node.querySelector && node.querySelector('a[href]');
        if (innerLink) {
          innerLink.click();
          return;
        }
        node.click && node.click();
      } catch (err) {}
    });

    list.appendChild(pill);
  });

  var hasAny = list.children.length > 0;
  appliedRoot.hidden = !hasAny;
  if (hasAny) appliedRoot.removeAttribute('hidden');

  // Accordion behavior for applied filters section (UI-only)
  if (!headerBtn.__wzBound) {
    headerBtn.__wzBound = true;
    headerBtn.addEventListener('click', function () {
      var collapsed = appliedRoot.classList.toggle('is-collapsed');
      headerBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  }
}

function wizzyFacetDebugEnabled() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('wizzyDebugFacets') === '1';
  } catch (e) {
    return false;
  }
}

function wizzyFacetDebugLog() {
  if (!wizzyFacetDebugEnabled()) return;
  var a = Array.prototype.slice.call(arguments);
  a.unshift('[Wizzy facets]');
  console.log.apply(console, a);
}

/** When Wizzy renders Color as a plain list (no isSwatch), inject swatch squares + classes so Rivasat CSS applies. */
var WIZZY_FACET_COLOR_NAME_FALLBACKS = {
  pink: '#e89198',
  'light pink': '#f8bbd9',
  red: '#c62828',
  orange: '#fb8c00',
  white: '#ffffff',
  green: '#2e7d32',
  purple: '#7b1fa2',
  yellow: '#f9a825',
  beige: '#d7ccc8',
  cream: '#fffde7',
  black: '#212121',
  blue: '#1976d2',
  grey: '#9e9e9e',
  gray: '#9e9e9e',
  brown: '#795548',
  multicolor: 'linear-gradient(135deg,#e53935 0%,#fdd835 40%,#43a047 70%,#1e88e5 100%)',
  multicolour: 'linear-gradient(135deg,#e53935 0%,#fdd835 40%,#43a047 70%,#1e88e5 100%)',
};

function wizzyFacetStripCountSuffix(s) {
  return String(s || '')
    .replace(/\s*\(\s*\d+\s*\)\s*$/, '')
    .trim();
}

function wizzyFacetColorStyleFromMap(rawLabel) {
  var name = wizzyFacetStripCountSuffix(rawLabel);
  if (!name) {
    wizzyFacetDebugLog('color style: empty label');
    return { css: 'background-color:#e0e0e0' };
  }
  var val = colorMap[name];
  if (val == null) {
    var keys = Object.keys(colorMap);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === name.toLowerCase()) {
        val = colorMap[keys[i]];
        break;
      }
    }
  }
  if (val == null) {
    var fb = WIZZY_FACET_COLOR_NAME_FALLBACKS[name.toLowerCase()];
    if (fb != null) {
      if (fb.indexOf('linear-gradient') === 0) {
        return { css: 'background:' + fb };
      }
      return { css: 'background-color:' + fb };
    }
    wizzyFacetDebugLog('color map miss (using neutral)', name);
    return { css: 'background-color:#d4d4d4' };
  }
  if (/\.(png|jpg|jpeg|webp|gif)(\?.*)?$/i.test(String(val))) {
    wizzyFacetDebugLog('color uses bitmap swatch (gradient fallback)', name, val);
    return { css: 'background:linear-gradient(135deg,#e53935 0%,#fdd835 40%,#43a047 70%,#1e88e5 100%)' };
  }
  return { css: 'background-color:' + val };
}

/**
 * Resolve Wizzy product card swatch fill (hex / image URL). Mustache only supports
 * background-color OR background-image:url(swatchValue) — not full CSS strings.
 */
function wizzyResolveProductSwatchValue(val) {
  var neutral = '#d4d4d4';
  var rawLabel =
    val && (val.value != null && val.value !== '' ? val.value : val.label != null && val.label !== '' ? val.label : val.name);
  rawLabel = String(rawLabel || '').trim();

  var existing = val && val.swatchValue != null ? String(val.swatchValue).trim() : '';
  if (existing) {
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(existing)) {
      return { swatchValue: existing, isURLSwatch: false };
    }
    if (/^rgba?\(/i.test(existing)) {
      return { swatchValue: existing, isURLSwatch: false };
    }
    if (/^https?:\/\//i.test(existing) || /\.(png|jpg|jpeg|webp|gif)(\?.*)?$/i.test(existing)) {
      return { swatchValue: existing, isURLSwatch: true };
    }
  }

  if (!rawLabel) {
    return { swatchValue: neutral, isURLSwatch: false };
  }

  var name = wizzyFacetStripCountSuffix(rawLabel);
  var mapVal = colorMap[name];
  if (mapVal == null) {
    var keys = Object.keys(colorMap);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === name.toLowerCase()) {
        mapVal = colorMap[keys[i]];
        break;
      }
    }
  }

  if (mapVal != null) {
    var s = String(mapVal).trim();
    if (/\.(png|jpg|jpeg|webp|gif)(\?.*)?$/i.test(s)) {
      return { swatchValue: s, isURLSwatch: true };
    }
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(s) || /^rgba?\(/i.test(s)) {
      return { swatchValue: s, isURLSwatch: false };
    }
    return { swatchValue: s, isURLSwatch: false };
  }

  var lk = name.toLowerCase();
  var fb = WIZZY_FACET_COLOR_NAME_FALLBACKS[lk];
  if (fb == null && lk.indexOf(' ') !== -1) {
    fb = WIZZY_FACET_COLOR_NAME_FALLBACKS[lk.split(/\s+/)[0]];
  }
  if (fb != null) {
    if (String(fb).indexOf('linear-gradient') === 0) {
      return { swatchValue: '#9e9e9e', isURLSwatch: false };
    }
    return { swatchValue: String(fb), isURLSwatch: false };
  }

  wizzyFacetDebugLog('product swatch: no map for', rawLabel);
  return { swatchValue: neutral, isURLSwatch: false };
}

function wizzyNormalizeVariantId(raw) {
  var variantId = raw != null ? String(raw).trim() : '';
  if (!variantId) return '';
  if (!/^\d+$/.test(variantId)) {
    var m = variantId.match(/(\d+)(?!.*\d)/);
    if (m) variantId = m[1];
  }
  return /^\d+$/.test(variantId) ? variantId : '';
}

function wizzyExtractCardSizes(product) {
  // Returns [{ label: "XS", variantId: "123" }, ...]
  var out = [];

  try {
    var swatches = product && product.swatches ? product.swatches : [];
    for (var i = 0; i < swatches.length; i++) {
      var k = swatches[i] && swatches[i].key != null ? String(swatches[i].key).toLowerCase() : '';
      if (k && (k === 'sizes' || k === 'size' || k.indexOf('size') !== -1)) {
        var vals = swatches[i].values || [];
        for (var j = 0; j < vals.length; j++) {
          var v = vals[j] || {};
          var label = v.value != null ? v.value : v.label != null ? v.label : v.name;
          label = String(label || '').trim();
          var variantId = wizzyNormalizeVariantId(v.variationId);
          if (label && variantId) out.push({ label: label, variantId: variantId });
        }
        break;
      }
    }
  } catch (e0) {}

  // If Wizzy doesn't provide a size swatch group with variationId, we cannot deep-link via ?variant=.
  // Return empty so UI doesn't show non-functional pills.
  var seen = {};
  var norm = [];
  for (var x = 0; x < out.length; x++) {
    var label2 = String(out[x].label || '').trim();
    var vid2 = String(out[x].variantId || '').trim();
    if (!label2 || !vid2) continue;
    var key2 = label2.toLowerCase() + '|' + vid2;
    if (seen[key2]) continue;
    seen[key2] = true;
    norm.push({ label: label2, variantId: vid2 });
  }
  return norm;
}

/** Sidebar, toolbar duplicate panel, or tile/grid strip — detect Colour facet blocks. */
function wizzyFacetBlockIsColorFacet(block) {
  if (!block) return false;
  var body = block.querySelector('.wizzy-facet-body');
  if (!body) return false;
  var cls = body.className || '';
  if (/facet-body-[^\s]*color/i.test(cls)) return true;
  if (/facet-body-product_Color/i.test(cls)) return true;
  if (/colour/i.test(cls)) return true;
  var head = block.querySelector('.wizzy-facet-head .facet-head-title, .wizzy-facet-head .rivasat-section-heading');
  var ht = ((head && head.textContent) || '').trim().toLowerCase();
  ht = ht.replace(/\u00a0/g, ' ').replace(/[?'']/g, '').replace(/\s+/g, ' ').trim();
  if (ht === 'color' || ht === 'colour' || ht === 'colors') return true;
  if (/\bcolors?\b/.test(ht) || /\bcolours?\b/.test(ht)) return true;
  if (/colour preference|color preference|select by colour|select by color/.test(ht)) return true;
  return false;
}

/**
 * When Wizzy renders Colour as plain labels (no isSwatch), inject a filled circle from colorMap / fallbacks.
 * Returns: 'existing' | 'injected' | 'skip'
 */
function wizzyFacetInjectColorSwatchIfMissing(li) {
  var label = li.querySelector('.wizzy-facet-list-item-label');
  if (!label) return 'skip';

  if (label.querySelector('.wizzy-facet-item-swatch-wrapper')) {
    li.classList.add('rivasat-color-item', 'facet-has-swatch');
    return 'existing';
  }

  if (li.getAttribute('data-wz-color-injected') === '1') return 'skip';

  var nameEl = label.querySelector('.facet-item-label-value');
  var raw =
    li.getAttribute('data-term') ||
    (nameEl && nameEl.textContent) ||
    '';
  var styleObj = wizzyFacetColorStyleFromMap(raw);

  var wrap = document.createElement('span');
  wrap.className = 'wizzy-facet-item-swatch-wrapper facet-visual-swatch rivasat-injected-swatch';
  var sw = document.createElement('span');
  sw.className = 'wizzy-facet-item-swatch facet-visual-swatch';
  sw.setAttribute('style', styleObj.css);
  wrap.appendChild(sw);
  label.insertBefore(wrap, label.firstChild);

  li.classList.add('rivasat-color-item', 'facet-has-swatch');
  li.setAttribute('data-wz-color-injected', '1');
  return 'injected';
}

function wizzyEnhanceColorFacetSwatches(scopeEl) {
  var root = scopeEl || document;
  var side = root.querySelector('.wizzy-search-filters-left.rivasat-filter-sidebar');
  if (!side) {
    wizzyFacetDebugLog('wizzyEnhanceColorFacetSwatches: no .rivasat-filter-sidebar');
    wizzyEnhanceGridFilterColorSwatches(root);
    return;
  }

  var blocks = side.querySelectorAll('.wizzy-filters-facet-block');
  var nInjected = 0;
  var nMarked = 0;

  Array.prototype.forEach.call(blocks, function (block) {
    if (!wizzyFacetBlockIsColorFacet(block)) return;
    var list = block.querySelector('.wizzy-facet-list');
    if (!list) return;

    Array.prototype.forEach.call(list.querySelectorAll('.wizzy-facet-list-item'), function (li) {
      var r = wizzyFacetInjectColorSwatchIfMissing(li);
      if (r === 'existing') nMarked++;
      else if (r === 'injected') nInjected++;
    });
  });

  wizzyFacetDebugLog('color facets: swatches injected', nInjected, 'existing marked', nMarked);
  wizzyEnhanceGridFilterColorSwatches(root);
}

/** Tile/grid colour row: same swatch injection as sidebar when Wizzy omits isSwatch. */
function wizzyEnhanceGridFilterColorSwatches(scopeEl) {
  var root = scopeEl || document;
  var boxes = root.querySelectorAll('.wizzy-grid-filters-box.wizzy-filters-facet-block');
  var nInjected = 0;
  var nMarked = 0;

  Array.prototype.forEach.call(boxes, function (block) {
    if (!wizzyFacetBlockIsColorFacet(block)) return;
    var list = block.querySelector('.wizzy-facet-list');
    if (!list) return;

    Array.prototype.forEach.call(list.querySelectorAll('.wizzy-facet-list-item'), function (li) {
      var r = wizzyFacetInjectColorSwatchIfMissing(li);
      if (r === 'existing') nMarked++;
      else if (r === 'injected') nInjected++;
    });
  });

  if (nInjected || nMarked) {
    wizzyFacetDebugLog('grid filter color swatches: injected', nInjected, 'marked', nMarked);
  }
}

/** Top toolbar facets: keep all closed until the shopper opens one (pill / chevron / “Filters”). */
function wizzyTopFacetsCollapseAllToolbar(doc) {
  var toolbar = (doc || document).querySelector('.wizzy-search-filters-list-top');
  if (!toolbar) return;
  toolbar.querySelectorAll('.wizzy-filters-facet-block.facet-block-top').forEach(function (b) {
    b.classList.add('collapsed');
  });
}

/** Collapse toolbar facets only when the facet set changes (new search / layout), not on every VIEW_RENDERED. */
function wizzyTopFacetsCollapseToolbarIfFacetStructureChanged(doc) {
  doc = doc || document;
  var toolbar = doc.querySelector('.wizzy-search-filters-list-top');
  if (!toolbar) return;
  var blocks = toolbar.querySelectorAll('.wizzy-filters-facet-block.facet-block-top[data-key]');
  var sig = Array.prototype.map
    .call(blocks, function (b) {
      return b.getAttribute('data-key') || '';
    })
    .join('\x1e');
  if (!sig) return;
  if (doc.__wzToolbarFacetStructureSig === sig) return;
  doc.__wzToolbarFacetStructureSig = sig;
  wizzyTopFacetsCollapseAllToolbar(doc);
}

/** Wizzy sometimes leaves 2+ top facets expanded — only one open row matches reference (img-3). */
function wizzyToolbarTopFacetsEnforceSingleOpen(doc, preferBlock) {
  var toolbar = (doc || document).querySelector('.wizzy-search-filters-list-top');
  if (!toolbar) return;
  var blocks = Array.prototype.slice.call(toolbar.querySelectorAll('.wizzy-filters-facet-block.facet-block-top'));
  var open = blocks.filter(function (b) {
    return !b.classList.contains('collapsed');
  });
  if (open.length <= 1) return;
  var keep =
    preferBlock && open.indexOf(preferBlock) !== -1 ? preferBlock : open[open.length - 1];
  open.forEach(function (b) {
    if (b !== keep) b.classList.add('collapsed');
  });
}

/** Safe Element from click target (avoids tagName on null for analytics / delegated code). */
function wizzyClickTargetElement(ev) {
  var n = ev && ev.target;
  if (!n) return null;
  if (n.nodeType === 1) return n;
  if (n.nodeType === 3 && n.parentElement) return n.parentElement;
  return null;
}

/** PLP: remove inline background Wizzy may set during AJAX so theme CSS (stable surface) always applies. */
function wizzyStabilizePlpBackgrounds(doc) {
  doc = doc || document;
  function clearBg(el) {
    if (!el || !el.style) return;
    try {
      el.style.removeProperty('background');
      el.style.removeProperty('background-color');
    } catch (e) {}
  }
  var wrap = doc.querySelector('.wizzy-search-wrapper');
  if (wrap) {
    clearBg(wrap);
    clearBg(wrap.querySelector('.wizzy-search-results-wrapper'));
    clearBg(wrap.querySelector('.wizzy-search-results-container'));
    clearBg(wrap.querySelector('.wizzy-search-results'));
  }
  clearBg(doc.querySelector('height-observer.collection-toolbar.full-bleed'));
}

/** Toolbar top facets: toggle `collapsed` and sync duplicate value panels (Wizzy core click can throw with our layout). */
function wizzyToolbarTopFacetApplyToggle(doc, block, toolbar) {
  var others = toolbar.querySelectorAll('.wizzy-filters-facet-block.facet-block-top');
  var opening = block.classList.contains('collapsed');
  if (opening) {
    Array.prototype.forEach.call(others, function (b) {
      if (b !== block) b.classList.add('collapsed');
    });
    block.classList.remove('collapsed');
  } else {
    block.classList.add('collapsed');
  }
  try {
    wizzyTopFacetPanelsSync(doc);
  } catch (eSync) {}
}

/** Top-position facets: Wizzy can leave multiple value panels open; keep one panel visible and match toolbar `data-key`. */
function wizzyTopFacetPanelsSync(root) {
  var doc = root || document;
  var wrap = doc.querySelector('.wizzy-search-wrapper.has-top-facets .filters-list-top-values-wrapper');
  var toolbar = doc.querySelector('.wizzy-search-filters-list-top');
  if (!toolbar) return;

  wizzyToolbarTopFacetsEnforceSingleOpen(doc, null);

  if (!wrap) return;

  function stripTopValuesPanelVisible() {
    Array.prototype.forEach.call(wrap.children, function (el) {
      el.classList.remove('wz-top-facet-panel-visible');
    });
  }

  var panelsRaw = wrap.querySelectorAll('.wizzy-grid-filters-box, .wizzy-filters-facet-block[data-key]');
  var panels = Array.prototype.filter.call(panelsRaw, function (node) {
    return node.getAttribute('data-key');
  });

  var openBlocks = [];
  toolbar.querySelectorAll('.wizzy-filters-facet-block[data-key]').forEach(function (b) {
    if (!b.classList.contains('collapsed')) openBlocks.push(b);
  });

  if (!panels.length) {
    stripTopValuesPanelVisible();
    return;
  }

  if (!openBlocks.length) {
    panels.forEach(function (p) {
      p.classList.remove('wz-top-facet-panel-visible');
    });
    stripTopValuesPanelVisible();
    return;
  }

  var keepKey;
  if (openBlocks.length > 1) {
    var keep = openBlocks[openBlocks.length - 1];
    keepKey = keep.getAttribute('data-key');
    toolbar.querySelectorAll('.wizzy-filters-facet-block[data-key]').forEach(function (b) {
      if (b !== keep) b.classList.add('collapsed');
    });
  } else {
    keepKey = openBlocks[0].getAttribute('data-key');
  }

  if (!keepKey) {
    stripTopValuesPanelVisible();
    return;
  }

  panels.forEach(function (p) {
    var k = p.getAttribute('data-key');
    if (!k) return;
    p.classList.toggle('wz-top-facet-panel-visible', k === keepKey);
  });
}

/**
 * Wizzy wires filter apply to the duplicate panel in `.filters-list-top-values-wrapper`.
 * Top toolbar facet bodies are outside that subtree, so mirror checkbox state to the hidden panel.
 */
function wizzyFindTopValuesPanelByKey(wrap, key) {
  if (!wrap || !key) return null;
  var nodes = wrap.querySelectorAll('.wizzy-grid-filters-box[data-key], .wizzy-filters-facet-block[data-key]');
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].getAttribute('data-key') === key) return nodes[i];
  }
  return null;
}

function wizzyMirrorToolbarCheckboxChangeToValuesPanel(doc, ev) {
  var t = ev.target;
  if (!t || t.tagName !== 'INPUT' || t.type !== 'checkbox') return;
  if (!t.classList || !t.classList.contains('wizzy-facet-list-item-checkbox-input')) return;
  var toolbar = (doc || document).querySelector('.wizzy-search-filters-list-top');
  if (!toolbar || !toolbar.contains(t)) return;
  var li = t.closest('.wizzy-facet-list-item');
  var block = t.closest('.wizzy-filters-facet-block.facet-block-top');
  if (!li || !block) return;
  var key = block.getAttribute('data-key');
  var term = li.getAttribute('data-term');
  if (!key) return;
  var wrap = (doc || document).querySelector('.wizzy-search-wrapper.has-top-facets .filters-list-top-values-wrapper');
  if (!wrap) return;
  var panel = wizzyFindTopValuesPanelByKey(wrap, key);
  if (!panel) return;
  var twinLis = panel.querySelectorAll('.wizzy-facet-list-item[data-term]');
  var twinLi = null;
  for (var j = 0; j < twinLis.length; j++) {
    if (twinLis[j].getAttribute('data-term') === term) {
      twinLi = twinLis[j];
      break;
    }
  }
  if (!twinLi) return;
  var twinInput = twinLi.querySelector('input.wizzy-facet-list-item-checkbox-input');
  if (!twinInput || twinInput === t) return;
  if (twinInput.checked === t.checked) return;
  twinInput.checked = t.checked;
  try {
    twinInput.dispatchEvent(new Event('change', { bubbles: true }));
    twinInput.dispatchEvent(new Event('input', { bubbles: true }));
  } catch (eDispatch) {}
}

function wizzyInitToolbarFacetCheckboxMirror(scopeEl) {
  var doc = scopeEl || document;
  if (doc.documentElement.__wzToolbarFacetCheckboxMirror) return;
  doc.documentElement.__wzToolbarFacetCheckboxMirror = true;
  doc.addEventListener(
    'change',
    function (e) {
      try {
        wizzyMirrorToolbarCheckboxChangeToValuesPanel(doc, e);
      } catch (eM) {}
    },
    false
  );
}

function wizzyInitTopFacetExclusiveExpand(scopeEl) {
  var doc = scopeEl || document;
  var toolbar = doc.querySelector('.wizzy-search-filters-list-top');
  var wrap = doc.querySelector('.wizzy-search-wrapper.has-top-facets .filters-list-top-values-wrapper');

  var schedule = function () {
    window.setTimeout(function () {
      try {
        wizzyToolbarTopFacetsEnforceSingleOpen(doc, null);
        wizzyTopFacetPanelsSync(doc);
      } catch (e0) {}
    }, 60);
  };

  /* Close top filter when Sort is opened to avoid overlap */
if (!doc.documentElement.__wzSortCloseTopFacetBound) {
  doc.documentElement.__wzSortCloseTopFacetBound = true;

  doc.addEventListener(
    'click',
    function (e) {
      var el = wizzyClickTargetElement(e);
      if (!el || !el.closest) return;

      var sortWrapper = el.closest('.wizzy-search-sort-wrapper');
      if (!sortWrapper) return;

      wizzyTopFacetsCollapseAllToolbar(doc);
      wizzyTopFacetPanelsSync(doc);
    },
    true
  );
}

  /* Outside toolbar / values wrapper: collapse sync (once on document). */
  if (!doc.documentElement.__wzTopFacetToolbarOutsideClick) {
    doc.documentElement.__wzTopFacetToolbarOutsideClick = true;
    doc.addEventListener(
      'click',
      function (e) {
        var t = doc.querySelector('.wizzy-search-filters-list-top');
        var w = doc.querySelector('.wizzy-search-wrapper.has-top-facets .filters-list-top-values-wrapper');
        if (!t) return;
        var el = wizzyClickTargetElement(e);
        if (!el) return;
        if (t.contains(el) || (w && w.contains(el))) return;
        schedule();
      },
      false
    );
  }

  /* Capture on toolbar (not document): runs before Wizzy’s bubble handlers on the facet head; avoids breaking other document listeners. */
  if (toolbar && !toolbar.__wzTopFacetToolbarCaptureBound) {
    toolbar.__wzTopFacetToolbarCaptureBound = true;
    toolbar.addEventListener(
      'click',
      function (e) {
        if (e.defaultPrevented) return;
        var el = wizzyClickTargetElement(e);
        if (!el || !el.closest) return;
        if (!toolbar.contains(el)) return;
        var head = el.closest('.wizzy-facet-head');
        if (!head || !toolbar.contains(head)) return;
        if (el.closest('.facet-search-wrapper')) return;
        var tag = el.tagName;
        if (tag === 'A' || tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return;
        var block = head.closest('.wizzy-filters-facet-block.facet-block-top');
        if (!block || !toolbar.contains(block)) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        wizzyToolbarTopFacetApplyToggle(doc, block, toolbar);
      },
      true
    );
  }

  try {
    if (wrap && !wrap.__wzTopFacetWrapMo) {
      wrap.__wzTopFacetWrapMo = true;
      var mo = new MutationObserver(function () {
        schedule();
      });
      mo.observe(wrap, { childList: true });
    }
  } catch (eObs) {}

  try {
    if (toolbar && !toolbar.__wzToolbarFacetClassMo) {
      toolbar.__wzToolbarFacetClassMo = new MutationObserver(function () {
        window.clearTimeout(toolbar.__wzToolbarFacetClassT);
        toolbar.__wzToolbarFacetClassT = window.setTimeout(function () {
          try {
            wizzyToolbarTopFacetsEnforceSingleOpen(doc, null);
            wizzyTopFacetPanelsSync(doc);
          } catch (eMo) {}
        }, 25);
      });
      toolbar.__wzToolbarFacetClassMo.observe(toolbar, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });
    }
  } catch (eToolbarMo) {}

  if (!toolbar) return;
  schedule();
  window.setTimeout(schedule, 120);
  window.setTimeout(schedule, 400);
}

/** Rivasat sidebar: Wizzy/theme accordion sometimes sets inline max-height → inner scroll + large visual gap. */
function wizzyNormalizeRivasatFacetAccordionLayout(scopeEl) {
  var root = scopeEl || document;
  var side = root.querySelector('.wizzy-search-filters-left.rivasat-filter-sidebar');
  if (!side) return;
  Array.prototype.forEach.call(side.querySelectorAll('.wizzy-facet-body'), function (body) {
    body.style.maxHeight = 'none';
    body.style.overflow = 'visible';
  });
  /* Wizzy can assign max-height on facet <ul> → inner scrollbar; keep full list in flow for See More / See Less. */
  Array.prototype.forEach.call(side.querySelectorAll('ul.wizzy-facet-list'), function (ul) {
    ul.style.maxHeight = 'none';
    ul.style.overflowY = 'visible';
    ul.style.overflow = 'visible';
    ul.style.height = 'auto';
  });
}

function wizzyBindFacetCheckboxUI(scopeEl) {
  // UI-only: ensure checkbox visuals reflect user interaction, even if Wizzy doesn't toggle `checked`.
  var root = scopeEl || document;
  var wrapper = root.querySelector('.wizzy-search-wrapper');
  if (!wrapper) return;

  function normalizeFacetLabel(s) {
    return String(s || '')
      .replace(/\(\s*\d+\s*\)\s*$/g, '') // drop trailing "(12)"
      .replace(/[×✕]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function addTermFromRawText(terms, raw) {
    var txt = String(raw || '').replace(/[×✕]/g, '').trim();
    if (!txt) return;
    var parts = txt.split(':');
    var maybeValue = parts.length >= 2 ? parts.slice(1).join(':') : txt;
    var cleaned = normalizeFacetLabel(maybeValue);
    if (cleaned) terms.add(cleaned);
  }

  function collectSelectedTermsFromAppliedFilters() {
    var terms = new Set();

    // 1) Pills built by wizzyNormalizeAppliedFilters — most reliable (label is first <span>).
    var pills = root.querySelectorAll('[data-wz-applied-filters] .custom-applied-filters__pill');
    Array.prototype.forEach.call(pills, function (pill) {
      var labelSpan = pill.querySelector('span:not(.custom-applied-filters__remove)');
      var txt = (labelSpan && labelSpan.textContent) || pill.textContent || '';
      addTermFromRawText(terms, txt);
    });

    // 2) Hidden Wizzy source: real remove links / list items.
    var appliedSource = root.querySelector('[data-wz-applied-filters] .custom-applied-filters__source');
    if (appliedSource) {
      var anchorLinks = Array.prototype.slice.call(appliedSource.querySelectorAll('a[href]')).filter(function (a) {
        var href = a.getAttribute('href') || '';
        return href && href !== '#';
      });
      anchorLinks.forEach(function (a) {
        addTermFromRawText(terms, a.textContent || '');
      });
      if (!terms.size) {
        Array.prototype.forEach.call(appliedSource.querySelectorAll('li'), function (li) {
          addTermFromRawText(terms, li.textContent || '');
        });
      }
    }

    // 3) Top bar selected summary (if visible in other layouts)
    var top = root.querySelector('.wizzy-search-filters-top .wizzy-selected-filters');
    if (top && !terms.size) {
      Array.prototype.forEach.call(top.querySelectorAll('a[href]'), function (a) {
        var href = a.getAttribute('href') || '';
        if (href && href !== '#') addTermFromRawText(terms, a.textContent || '');
      });
    }

    wizzyFacetDebugLog('collectSelectedTerms →', Array.from(terms));
    return terms;
  }

  function rowMatchesSelectedTerms(rowTerm, selectedTerms) {
    if (!rowTerm || !selectedTerms.size) return false;
    if (selectedTerms.has(rowTerm)) return true;
    var match = false;
    selectedTerms.forEach(function (t) {
      if (match) return;
      if (!t) return;
      if (rowTerm === t) match = true;
      else if (rowTerm.indexOf(t + ' ') === 0) match = true;
      else if (t.indexOf(rowTerm + ' ') === 0) match = true;
    });
    return match;
  }

  function syncFacetRowsFromAppliedFilters() {
    var selectedTerms = collectSelectedTermsFromAppliedFilters();
    if (!selectedTerms.size) {
      wizzyFacetDebugLog('syncFacetRows: no selected terms from applied filters; leaving Wizzy DOM as-is');
      return;
    }

    var verbose = false;
    try {
      verbose = localStorage.getItem('wizzyDebugFacetsVerbose') === '1';
    } catch (e) {}

    var nMatched = 0;
    wrapper.querySelectorAll('.wizzy-facet-list-item').forEach(function (li) {
      var input = li.querySelector('input.wizzy-facet-list-item-checkbox-input');
      if (!input) return;

      input.classList.add('wz-checkbox'); // ensure CSS hook

      var dataTerm = li.getAttribute('data-term') || '';
      var termFromAttr = normalizeFacetLabel(dataTerm);
      var termFromText = normalizeFacetLabel(li.textContent || '');
      var term = termFromAttr || termFromText;
      var isSelected = rowMatchesSelectedTerms(term, selectedTerms);

      if (verbose) {
        wizzyFacetDebugLog('sync row', { dataTerm: dataTerm, normalized: term, isSelected: isSelected });
      }
      if (isSelected) nMatched++;

      li.classList.toggle('active', isSelected);
      input.checked = isSelected;
      if (isSelected) {
        input.setAttribute('checked', 'checked');
      } else {
        input.removeAttribute('checked');
      }
    });
    wizzyFacetDebugLog('syncFacetRows: matched', nMatched, 'facet rows to applied terms');
  }

  // Always re-sync on every VIEW_RENDERED call (Wizzy re-renders DOM frequently).
  // But only bind click handlers once.
  wrapper.__wzSyncFacetRowsFromAppliedFilters = syncFacetRowsFromAppliedFilters;

  if (wrapper.__wzFacetCheckboxBound) {
    try {
      syncFacetRowsFromAppliedFilters();
      setTimeout(syncFacetRowsFromAppliedFilters, 50);
      setTimeout(syncFacetRowsFromAppliedFilters, 200);
    } catch (e) {}
    return;
  }
  wrapper.__wzFacetCheckboxBound = true;

  // Initial sync (on render)
  wrapper.querySelectorAll('.wizzy-facet-list-item').forEach(function (li) {
    var input = li.querySelector('input.wizzy-facet-list-item-checkbox-input');
    if (!input) return;
    // Ensure our styling class is present even if templates differ
    input.classList.add('wz-checkbox');
    if (input.checked || input.hasAttribute('checked')) {
      li.classList.add('active');
    }
  });

  // If Wizzy doesn't mark selected facet rows, infer from applied-filters summary.
  // Run now and again shortly after to handle async facet rendering.
  try {
    syncFacetRowsFromAppliedFilters();
    setTimeout(syncFacetRowsFromAppliedFilters, 50);
    setTimeout(syncFacetRowsFromAppliedFilters, 200);
  } catch (e) {}

  // Click sync (optimistic UI). Use rAF so native checkbox toggle runs first when clicking the input.
  wrapper.addEventListener(
    'click',
    function (e) {
      var li = e.target && e.target.closest && e.target.closest('.wizzy-facet-list-item');
      if (!li) return;
      var input = li.querySelector('input.wizzy-facet-list-item-checkbox-input');
      if (!input) return;

      var clickedCheckbox = e.target === input;
      var apply = function () {
        var nextSelected = clickedCheckbox ? input.checked : !li.classList.contains('active');
        li.classList.toggle('active', nextSelected);
        input.checked = nextSelected;
        if (nextSelected) {
          input.setAttribute('checked', 'checked');
        } else {
          input.removeAttribute('checked');
        }
        wizzyFacetDebugLog('click sync', {
          clickedCheckbox: clickedCheckbox,
          nextSelected: nextSelected,
          inputChecked: input.checked,
        });
      };

      if (clickedCheckbox) {
        requestAnimationFrame(apply);
      } else {
        apply();
      }
    },
    false
  );
}

function wizzyInitPriceFacetUI(scopeEl) {
  // UI-only: make the price facet match the reference UI.
  // Syncs noUiSlider values <-> two ₹ inputs under the slider.
  var root = scopeEl || document;

  function formatINR(n) {
    if (n == null || n === '' || isNaN(Number(n))) return '';
    try {
      return new Intl.NumberFormat('en-IN').format(Math.round(Number(n)));
    } catch (e) {
      return String(Math.round(Number(n)));
    }
  }

  function parseNumber(val) {
    if (val == null) return null;
    var s = String(val).replace(/[₹,\s]/g, '').trim();
    if (!s) return null;
    var num = Number(s);
    return isNaN(num) ? null : num;
  }

  root.querySelectorAll('[data-wz-price-filter]').forEach(function (wrap) {
    var sliderHost = wrap.querySelector('.wizzy-facet-range-slider');
    var inputsWrap = wrap.querySelector('[data-wz-price-inputs]');
    if (!sliderHost || !inputsWrap) return;

    var inputs = inputsWrap.querySelectorAll('input.custom-price-filter__input');
    if (inputs.length < 2) return;
    var minInput = inputs[0];
    var maxInput = inputs[1];

    // Remove inner scrollbar caused by constrained facet-body styling
    var facetBody = wrap.closest('.wizzy-facet-body');
    if (facetBody) {
      facetBody.style.overflow = 'visible';
      facetBody.style.maxHeight = 'none';
    }

    function bindIfReady() {
      var slider = sliderHost.noUiSlider;
      if (!slider) return false;

      inputsWrap.hidden = false;

      if (!sliderHost.__wzPriceBound) {
        sliderHost.__wzPriceBound = true;

        slider.on('update', function (values) {
          var minV = parseNumber(values && values[0]);
          var maxV = parseNumber(values && values[1]);
          if (minV != null) minInput.value = formatINR(minV);
          if (maxV != null) maxInput.value = formatINR(maxV);
        });

        function applyInputsToSlider() {
          var minV = parseNumber(minInput.value);
          var maxV = parseNumber(maxInput.value);
          var current = slider.get();
          var curMin = parseNumber(current && current[0]);
          var curMax = parseNumber(current && current[1]);

          slider.set([
            minV == null ? curMin : minV,
            maxV == null ? curMax : maxV,
          ]);
        }

        minInput.addEventListener('blur', applyInputsToSlider);
        maxInput.addEventListener('blur', applyInputsToSlider);
        minInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyInputsToSlider();
          }
        });
        maxInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyInputsToSlider();
          }
        });
      }

      try {
        var v = slider.get();
        if (v && v.length >= 2) {
          minInput.value = formatINR(parseNumber(v[0]));
          maxInput.value = formatINR(parseNumber(v[1]));
        }
      } catch (e) {}

      return true;
    }

    if (bindIfReady()) return;
    if (!wrap.__wzPriceRetrying) {
      wrap.__wzPriceRetrying = true;
      var tries = 0;
      var t = setInterval(function () {
        tries += 1;
        if (bindIfReady() || tries > 20) clearInterval(t);
      }, 50);
    }
  });
}

function wizzySyncLayoutToolbarActiveStates() {
  var wrapper =
    document.querySelector('.wizzy-search-wrapper') ||
    wizzyResolveSearchWrapperFromLayoutSwitch(
      document.querySelector('.collection-toolbar__layout-switch-list')
    );

  if (!wrapper) return;

  if (!wrapper.hasAttribute('wizzy-tile-view-level')) {
    wrapper.setAttribute('wizzy-tile-view-level', '2');
  }

  if (!wrapper.hasAttribute('wizzy-mobile-grid')) {
    wrapper.setAttribute('wizzy-mobile-grid', 'large');
  }

  // Desktop
  var layoutRoot = document.querySelector('.collection-toolbar__layout-switch-list');
  if (layoutRoot) {
    var level = wrapper.getAttribute('wizzy-tile-view-level') || '2';

    layoutRoot.querySelectorAll('button').forEach(function (btn) {
      var value = btn.getAttribute('value'); // large, medium, compact
      btn.classList.toggle('is-active', value === level);
    });
  }

  // Mobile
  var mobileRoot = document.querySelector('.wizzy-search-layout-switch-mobile');
  if (mobileRoot) {
    var grid = wrapper.getAttribute('wizzy-mobile-grid') || 'large';

    mobileRoot.querySelectorAll('.wizzy-layout-btn-mobile').forEach(function (btn) {
      var g = btn.getAttribute('data-wizzy-mobile-grid');
      btn.classList.toggle('is-active', g === grid);
    });
  }
}
function wizzyResolveSearchWrapperFromLayoutSwitch(layoutSwitch) {
  var toolbar = layoutSwitch && layoutSwitch.closest('height-observer.collection-toolbar');
  var next = toolbar && toolbar.nextElementSibling;

  if (next && next.classList && next.classList.contains('wizzy-search-wrapper')) {
    return next;
  }

  return document.querySelector('.wizzy-search-wrapper');
}

if (!window.__wizzyLayoutToolbarClickBound) {
  window.__wizzyLayoutToolbarClickBound = true;

  document.addEventListener('click', function (e) {
    var btnDesktop = e.target.closest('.collection-toolbar__layout-switch-list button');
    var btnMobile = e.target.closest('.wizzy-search-layout-switch-mobile .wizzy-layout-btn-mobile');

    var layoutRoot = btnDesktop
      ? btnDesktop.closest('.collection-toolbar__layout-switch-list')
      : btnMobile && btnMobile.closest('.wizzy-search-layout-switch-mobile');

    if (!layoutRoot) return;

    var wrapper = wizzyResolveSearchWrapperFromLayoutSwitch(layoutRoot);
    if (!wrapper) return;

    // Desktop
    if (btnDesktop) {
      var value = btnDesktop.getAttribute('value'); // large, medium, compact
      if (!value) return;

      // map value → level (you can adjust if needed)
      var levelMap = {
        large: '1',
        medium: '2',
        compact: '3',
      };

      wrapper.setAttribute('wizzy-tile-view-level', levelMap[value] || '2');

      layoutRoot.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === btnDesktop);
      });

      return;
    }

    // Mobile
    if (btnMobile) {
      var grid = btnMobile.getAttribute('data-wizzy-mobile-grid');
      if (!grid) return;

      wrapper.setAttribute('wizzy-mobile-grid', grid);

      layoutRoot.querySelectorAll('.wizzy-layout-btn-mobile').forEach(function (b) {
        b.classList.toggle('is-active', b === btnMobile);
      });
    }
  });
}
window.onWizzyScriptLoaded = function () {
    // --- Facet behavior config (Saundh-style) ---

        window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (data) {
    // console.log("Hiiiiiiiiiiiiii");
    const selector =
      window.innerWidth < 768
        ? ".collection-info-content.collection-title-mobile"
        : ".collection-info-content.collection-title-desktop";

    const collectionTitle = document.querySelector(selector);
    const collectionMenu = document.querySelector(".shopify-section.category-menu-row");
    if(collectionMenu) collectionMenu.style.display = "none";
    // console.log("Collection Tool bar",collectionTitle);
    if (collectionTitle) {
      collectionTitle.style.display = "none";
    // console.log("Hiiiiiiiiiiiiii 222222222");
    }

    return data;
  }
);
    
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.attributeFacetValuesLimit = 100;
      try {
        wizzyStabilizePlpBackgrounds(document);
      } catch (eBg0) {}
      return data;
    }
  );
 

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach(function (product) {
        const url = new URL(product.url);
                url.searchParams.delete("variant"),
                product.url = url.toString();
        product?.attributes?.forEach(function (attr) {
          if (attr.id === "product_handle") {
            product.handle = attr.values?.[0]?.value?.[0];
          }
          if (attr.id === "product_tags") {
                var tags = attr?.values?.[0]?.value?.[0] || "";

                var normalizedTags = tags.toLowerCase();

                if (
                  normalizedTags.includes("bestsellers") ||
                  normalizedTags.includes("best seller")
                ) {
                  product.bestSeller = true;
                }

                if (normalizedTags.includes("ready to ship")) {
                  product.readyToShip = true;
                }
                if (normalizedTags.includes("new this week")) {
                  product.newThisWeek = true;
                }
              }
            if (attr.id === "product_badges_custom") {
              const allBadges = attr?.values
                ?.flatMap((item) => item?.value || [])
                ?.map((badge) => badge.toLowerCase()) || [];

              product.isExclusive = allBadges.some((badge) =>
                badge.includes("online exclusive")
              );

              product.isArrival = allBadges.some((badge) =>
                badge.includes("new arrival")
              );
            }
            if (attr.id === "product_available_redy_to_ship_option_custom") {
            const shipVal = attr.values[0].value[0];
            if(shipVal){
              product.variantSvg = true;
            }
            }

            });
        
        if (product.price && String(product.price).includes(".")) {
          product.price = String(product.price).split(".")[0];
        }
        if (product.sellingPrice && String(product.sellingPrice).includes(".")) {
          product.sellingPrice = String(product.sellingPrice).split(".")[0];
        }
        if (
          (product.sellingPrice === undefined || product.sellingPrice === null || String(product.sellingPrice).trim() === '') &&
          product.price != null &&
          String(product.price).trim() !== ''
        ) {
          product.sellingPrice = product.price;
        }

        try {
          var spNum = parseFloat(
            String(product.sellingPrice != null ? product.sellingPrice : '').replace(/[^\d.]/g, '')
          );
          var lpNum = parseFloat(String(product.price != null ? product.price : '').replace(/[^\d.]/g, ''));
          if (!isNaN(spNum) && !isNaN(lpNum) && lpNum <= spNum) {
            product.price = null;
          }
        } catch (ePriceCmp) {}

        // Card size pills (UI only): show only when multiple sizes exist.
        try {
          var sizes = wizzyExtractCardSizes(product);
          if (sizes && sizes.length > 1) {
            var baseUrl = String(product && (product.url || product.handle || '') || '');
            var joiner = baseUrl.indexOf('?') !== -1 ? '&' : '?';
            product.cardSizes = sizes.slice(0, 7).map(function (s) {
              return {
                label: s.label,
                variantId: s.variantId,
                href: baseUrl,
              };
            });
            product.hasCardSizes = true;
          } else {
            product.cardSizes = [];
            product.hasCardSizes = false;
          }
        } catch (eSizes) {}

        product?.swatches?.forEach((swatch) => {
            var sk = swatch && swatch.key != null ? String(swatch.key).toLowerCase() : '';
            if (sk === 'colors') {
              let valLen = swatch.values.length;
              if (valLen > 4) {
                var extraSwatchNum = valLen - 4;
                product.extraSwatchNum = extraSwatchNum;
                swatch.values = swatch.values.slice(0, 4);
              }
              swatch.values.forEach((val) => {
                  val.isSwatch = true;
                  val.isVisualSwatch = true;
                  var resolved = wizzyResolveProductSwatchValue(val);
                  val.swatchValue = resolved.swatchValue;
                  val.isURLSwatch = !!resolved.isURLSwatch;
                  var vid = wizzyNormalizeVariantId(val.variationId);
                  if (vid) {
                    var base = String(product && (product.url || product.handle || '') || '');
                    var j = base.indexOf('?') !== -1 ? '&' : '?';
                    val.cardHref = base;
                  }
              });
            }
        })
      });
      
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {

      const sourceElement = window.innerWidth < 768 ? document.querySelector(".wizzy-search-sort-wrapper.collection-toolbar__button-container.collection-title-mobile")
          : document.querySelector(".wizzy-search-sort-wrapper.collection-toolbar__button-container.collection-title-desktop");

    const targetDiv = document.querySelector(".wizzy-sort-container");
    console.log(sourceElement.contains(targetDiv));

    if (sourceElement && targetDiv && !sourceElement.contains(targetDiv)) {
      sourceElement.appendChild(targetDiv);
    }

    
      try {
        wizzyStabilizePlpBackgrounds(document);
      } catch (eBg1) {}
      wizzyEnsureWishlistIconConfig();
      try {
        wizzyInitPlpProductTitleClamp(document);
      } catch (eTitle0) {}
      try {
        const categoryTitle = window?.wizzyConfig?.common?.categoryName;
        const titleElements = document.querySelectorAll(".collection-info-content h2");

        if (titleElements.length && categoryTitle) {
          titleElements.forEach(function (titleElement) {
            titleElement.textContent = categoryTitle;
          });
        }
        wizzyTopFacetsCollapseToolbarIfFacetStructureChanged(document);
        wizzyNormalizeAppliedFilters(document);
        wizzyNormalizeRivasatFacetAccordionLayout(document);
        wizzyEnhanceColorFacetSwatches(document);
        wizzyInitFacetSectionSearch(document);
        wizzyBindFacetCheckboxUI(document);
        wizzyInitFacetSeeMore(document, 3);
        wizzyInitPriceFacetUI(document);
        wizzyInitToolbarFacetCheckboxMirror(document);
        wizzyInitTopFacetExclusiveExpand(document);
        wizzyTopFacetPanelsSync(document);
        window.setTimeout(function () {
          try {
            wizzyStabilizePlpBackgrounds(document);
            wizzyTopFacetPanelsSync(document);
          } catch (e0b) {}
        }, 0);
        window.setTimeout(function () {
          try {
            wizzyTopFacetPanelsSync(document);
          } catch (e0c) {}
        }, 90);
        setTimeout(function () {
          try {
            wizzyNormalizeAppliedFilters(document);
            wizzyNormalizeRivasatFacetAccordionLayout(document);
            wizzyEnhanceColorFacetSwatches(document);
            wizzyBindFacetCheckboxUI(document);
            wizzyInitFacetSeeMore(document, 3);
            wizzyTopFacetPanelsSync(document);
            wizzyInitPlpProductTitleClamp(document);
          } catch (e2) {}
        }, 200);
        setTimeout(function () {
          try {
            wizzyNormalizeAppliedFilters(document);
            wizzyNormalizeRivasatFacetAccordionLayout(document);
            wizzyEnhanceColorFacetSwatches(document);
            wizzyBindFacetCheckboxUI(document);
            wizzyInitFacetSeeMore(document, 3);
            wizzyTopFacetPanelsSync(document);
            wizzyInitPlpProductTitleClamp(document);
          } catch (e3) {}
        }, 600);
      } catch (e) {}
      try {
        if (typeof iWish !== "undefined") {
          // console.log("0");
          // iWish.checkIwishColl();
          if (typeof iWishinitFn === "function") {
          // console.log("1");
            iWishinitFn();
          }
          setTimeout(function () {
          // console.log("2");

            iWish.checkIwishColl();
            if (typeof iWishQV !== "undefined" && typeof iWishQV.init === "function") {
              iWishQV.init();
          // console.log("3");
            }
          }, 1500);
        }
      } catch (e) {}

      const collectionInfoContent = window.innerWidth < 768 ? document.querySelector(".collection-info-content.collection-title-mobile") : document.querySelector(".collection-toolbar__button-list .collection-info-content.collection-title-desktop");
      if(window.wizzyConfig.common.isOnCategoryPage) {
        if(collectionInfoContent) {
          collectionInfoContent.style.display = 'block';
        }
      } else {
          collectionInfoContent.style.display = 'none';
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      const sourceElement = window.innerWidth < 768 ? document.querySelector(".wizzy-search-sort-wrapper.collection-toolbar__button-container.collection-title-mobile")
          : document.querySelector(".wizzy-search-sort-wrapper.collection-toolbar__button-container.collection-title-desktop");

    const targetDiv = document.querySelector(".wizzy-sort-container");
    console.log(sourceElement.contains(targetDiv));

    if (sourceElement && targetDiv && !sourceElement.contains(targetDiv)) {
      sourceElement.appendChild(targetDiv);
    }

    
      try {
        wizzyStabilizePlpBackgrounds(document);
      } catch (eBg1) {}
      wizzyEnsureWishlistIconConfig();
      try {
        wizzyInitPlpProductTitleClamp(document);
      } catch (eTitle0) {}
      try {
        const categoryTitle = window?.wizzyConfig?.common?.categoryName;
        const titleElements = document.querySelectorAll(".collection-info-content h2");

        if (titleElements.length && categoryTitle) {
          titleElements.forEach(function (titleElement) {
            titleElement.textContent = categoryTitle;
          });
        }
        wizzyTopFacetsCollapseToolbarIfFacetStructureChanged(document);
        wizzyNormalizeAppliedFilters(document);
        wizzyNormalizeRivasatFacetAccordionLayout(document);
        wizzyEnhanceColorFacetSwatches(document);
        wizzyInitFacetSectionSearch(document);
        wizzyBindFacetCheckboxUI(document);
        wizzyInitFacetSeeMore(document, 3);
        wizzyInitPriceFacetUI(document);
        wizzyInitToolbarFacetCheckboxMirror(document);
        wizzyInitTopFacetExclusiveExpand(document);
        wizzyTopFacetPanelsSync(document);
        window.setTimeout(function () {
          try {
            wizzyStabilizePlpBackgrounds(document);
            wizzyTopFacetPanelsSync(document);
          } catch (e0b) {}
        }, 0);
        window.setTimeout(function () {
          try {
            wizzyTopFacetPanelsSync(document);
          } catch (e0c) {}
        }, 90);
        setTimeout(function () {
          try {
            wizzyNormalizeAppliedFilters(document);
            wizzyNormalizeRivasatFacetAccordionLayout(document);
            wizzyEnhanceColorFacetSwatches(document);
            wizzyBindFacetCheckboxUI(document);
            wizzyInitFacetSeeMore(document, 3);
            wizzyTopFacetPanelsSync(document);
            wizzyInitPlpProductTitleClamp(document);
          } catch (e2) {}
        }, 200);
        setTimeout(function () {
          try {
            wizzyNormalizeAppliedFilters(document);
            wizzyNormalizeRivasatFacetAccordionLayout(document);
            wizzyEnhanceColorFacetSwatches(document);
            wizzyBindFacetCheckboxUI(document);
            wizzyInitFacetSeeMore(document, 3);
            wizzyTopFacetPanelsSync(document);
            wizzyInitPlpProductTitleClamp(document);
          } catch (e3) {}
        }, 600);
      } catch (e) {}
      try {
        if (typeof iWish !== "undefined") {
          // console.log("0");
          // iWish.checkIwishColl();
          if (typeof iWishinitFn === "function") {
          // console.log("1");
            iWishinitFn();
          }
          setTimeout(function () {
          // console.log("2");

            iWish.checkIwishColl();
            if (typeof iWishQV !== "undefined" && typeof iWishQV.init === "function") {
              iWishQV.init();
          // console.log("3");
            }
          }, 1500);
        }
              const collectionInfoContent = window.innerWidth < 768 ? document.querySelector(".collection-info-content.collection-title-mobile") : document.querySelector(".collection-toolbar__button-list .collection-info-content.collection-title-desktop");
      if(window.wizzyConfig.common.isOnCategoryPage) {
        if(collectionInfoContent) {
          collectionInfoContent.style.display = 'block';
        }
      } else {
          collectionInfoContent.style.display = 'none';
      }
      } catch (e) {
        console.log("e",e);
      }



      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log("BEFORE_INIT",data);
    if (data?.common?.categoryName) {
      data.common.categoryName = getRevisedH1Tag(data.common.categoryName);
    }

      data.filters.configs.layout = "v1";
      window.wizzyConfig.filters.configs.displayAsDrawer = false;
      data.search.configs.facets.showPriceInputRangeFields = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.pagination.appendInExistingList = true;
      if(!window.wizzyConfig.common.isOnCategoryPage){
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
      }
      else if(window.wizzyConfig.common.isOnCategoryPage){
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"];
      }
      window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = "true";
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 1500
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.filters.configs.layout = "v1";
      if (data?.common?.categoryName) {
      data.common.categoryName = getRevisedH1Tag(data.common.categoryName);
    }
      window.wizzyConfig.filters.configs.displayAsDrawer = false;
      data.search.configs.facets.showPriceInputRangeFields = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.pagination.appendInExistingList = true;
      if(!window.wizzyConfig.common.isOnCategoryPage){
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
      }
      else if(window.wizzyConfig.common.isOnCategoryPage){
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"];
      }
      window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = "true";
      return data;
    }
  );
};



const searchLink = document.querySelector(".header__nav-icon.icon.icon-search");

if (searchLink) {
  searchLink.addEventListener("click", function () {

    setTimeout(function () {
      const input = document.querySelector(".header-search__input.h5");

      if (input) {
        input.click();
        input.focus(); // better UX
      }
    }, 500);

  });
}

setTimeout( () => {
    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
        const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
        autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? (document.body.classList.add("wizzy-autocomplete-open"),
        document.getElementsByTagName("html")[0].classList.add("wizzy-autocomplete-open")) : (document.body.classList.remove("wizzy-autocomplete-open"),
        document.getElementsByTagName("html")[0].classList.remove("wizzy-autocomplete-open"))
    }
    const wizzy_observer_config = {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["style"]
    }
      , callback = function(mutationsList, observer2) {
        for (const mutation of mutationsList) {
            updateBodyClass();
            break
        }
    }
      , observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, wizzy_observer_config),
    updateBodyClass())
}
, 1e3);
